export const STATUS_CHOICES = {
  DRAFT: 'Draft',
  RUNNING: 'Running',
  DONE: 'Done',
  ERROR: 'Error'
}
